<div>


  <div *ngIf="entry" class="writer-container">
    <div class="grow-wrap">
    <textarea #textAreaElement
              class="writer"
              placeholder="Start writing..."
              rows="1"
              [(ngModel)]="entry.content"
              (input)="onInput($event)">
    </textarea>
    </div>
    <div class="top-blend"></div>
    <div class="writer-header py-5 px-20">
      <div>{{ topic?.name }}</div>
      <div style="width: 200px;">
        <ion-range *ngIf="entry && topic &&  topic?.range_target"
                   [value]="entry.value"
                   step="0.05"
                   [snaps]="true"
                   min="0"
                   max="1"
                   [color]="{entry, topic} | rangeTrackerColor"
                   (ionChange)="updateValue($event)">
        </ion-range>
      </div>
    </div>
  </div>

  <div *ngIf="!entry"
       class="p-20">
    Choose a topic over the esc menu!
  </div>


</div>
